module.exports = __webpack_public_path__ + "static/media/pins2.01444a6f.jpg";